module.exports = __webpack_public_path__ + "static/shuttleid-simple-package-privacy-policy-updated-may-2025-03156dde032ab24ee41b232f903aad73.pdf";